import '../appInit';

import { createRoot } from 'react-dom/client';

import { startAppInsights } from '../appInsights';
import AsyncView from 'components/asyncView';

import '@iframe-resizer/child';

window.iframeResizer = {
  license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz'
};

const Scheduler = async() => ({ default: (await import('./scheduler')).FromWindowSchedulerView });

// Start the app
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<AsyncView view={Scheduler} />);

// Azure App Insights
startAppInsights('Calendar');